import styled from '@emotion/styled';

import { focusRing } from '@/shared/design-system';

const FUNDS_TREE_TRUNK_LEFT = 24;
const FUNDS_TREE_BRANCH_WIDTH = 24;

export const DirectorCell = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing[8],
}));

export const DirectorHintTrigger = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  borderRadius: theme.radius[8],
  cursor: 'help',
  ...focusRing(theme, { inset: false }),
}));

export const MemberActionsRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing[8],
}));

export const NameCell = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing[8],
  minWidth: 0,
}));

export const StatusCell = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StatusTooltipTrigger = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  borderRadius: theme.radius[8],
  cursor: 'help',
  ...focusRing(theme, { inset: false }),
}));

export const ToolbarRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing[8],
  width: '100%',
}));

export const SearchField = styled('div')({
  flex: 1,
  minWidth: 0,
});

export const HeaderRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing[16],
  width: '100%',
}));

export const UserDetailsRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[24],
  width: '100%',
}));

export const FiltersDrawerBody = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[20],
}));

export const FiltersField = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[8],
}));

export const LoadMoreSentinel = styled('div')({
  height: 20,
});

export const LoadMoreSpinner = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing[16],
}));

export const ExpandedRowWrapper = styled('div')(({ theme }) => ({
  borderTop: `1px solid ${theme.colors.border.default}`,
}));

export const FundsTree = styled('div')({
  position: 'relative',
});

export const FundsTreeTrunk = styled('div')<{ $height: number }>(({ theme, $height }) => ({
  position: 'absolute',
  top: 0,
  left: FUNDS_TREE_TRUNK_LEFT,
  height: $height,
  borderLeft: `1px solid ${theme.colors.border.default}`,
  pointerEvents: 'none',
}));

export const FundsTreeBranch = styled('div')<{ $top: number }>(({ theme, $top }) => ({
  position: 'absolute',
  top: $top,
  left: FUNDS_TREE_TRUNK_LEFT,
  width: FUNDS_TREE_BRANCH_WIDTH,
  borderTop: `1px solid ${theme.colors.border.default}`,
  pointerEvents: 'none',
}));

export const FundActionsRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing[8],
}));

export const FundTitleCell = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing[8],
  minWidth: 0,
  width: '100%',
}));

export const FundTitleText = styled('div')({
  minWidth: 0,
  flex: 1,
});

export const FundTitleAction = styled('div')({
  flexShrink: 0,
});
